export const isWithinPaths = (
  pathname: string,
  paths: readonly string[],
): boolean => paths.some((path) => pathname.startsWith(path));
